import { ACCESS_TOKEN } from '../constant'

export class AuthService {
  constructor(gaApp) {
    this.gaApp = gaApp
  }

  /**
   * Инициализация, получение данных пользователя
   */
  async init() {
    if (this.gaApp.config.get('dev')) {
      const token = this.gaApp.route.query?.token || this.getToken()

      if (token) {
        this.setToken(token)
        await this.gaApp.services.main.user.getUser()
        this.gaApp.services.main.user.setAuthorized()
        this.gaApp.eventBus.publish('user/auth/login')
      }

      return
    }

    // ждем, чтобы подтянулись нужные данные
    await this.gaApp.services.app.bridge.sendGetUserMessage()
  }

  /** Запись токена */
  setToken(token) {
    const getExpires = (expiresAfterS) => {
      return new Date(Date.now() + expiresAfterS * 1000)
    }

    this.gaApp.cookies.set('ga_game_token', token, {
      expires: getExpires(31536000),
      path: '/',
      sameSite: 'lax',
    })

    return this.gaApp.services.app.browserStorage.session.set(
      ACCESS_TOKEN,
      token,
    )
  }

  /** Получение токена */
  getToken() {
    return (
      this.gaApp.cookies.get('ga_game_token') ||
      this.gaApp.services.app.browserStorage.session.get(ACCESS_TOKEN)
    )
  }

  /** Сброс авторизации */
  resetAuth() {
    this.gaApp.cookies.remove('ga_game_token')
    this.gaApp.services.app.browserStorage.session.remove(ACCESS_TOKEN)
    this.gaApp.services.app.apm.addLabels({ phone: null })
    this.gaApp.services.main.user.setAuthorized(false)
    this.gaApp.eventBus.publish('user/auth/logout')
    this.gaApp.services.app.bridge.sendAuthMessage()
  }

  /**
   * Принудительное обновления токена
   */
  refreshToken() {
    return this.gaApp.services.app.bridge.sendRefreshTokenMessage()
  }
}
